import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { filter, map } from 'rxjs/operators';
import { User } from './models/user';
import { AuthService } from './services/auth.service';
import { SplitPreviewService } from './services/split-preview.service';
import { ThemeService } from './services/theme.service';
import { TicketService } from './services/ticket.service';
import { TicketDialogComponent } from './tickets/ticket-dialog/ticket-dialog.component';
@Component({
  selector: 'root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  isLoggedIn: boolean;
  user: User;

  loading: boolean = false;
  splitPreviewState$ = this.splitPreviewService.state$;


  constructor(private authService: AuthService,
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private splitPreviewService: SplitPreviewService,
    private themeService: ThemeService,
    private dialog: MatDialog,
    private ticketService: TicketService) {
    //global locale setting
    moment.locale('it');

    authService.loggedIn.subscribe(newValue => {
      this.isLoggedIn = newValue;
    });

    this.user = this.authService.getLoggedInUserFromLocalStorage();

    authService.loggedInUser.subscribe(newValue => {
      this.user = newValue;
      // Sync theme color when user changes
      if (newValue?.theme_color) {
        this.themeService.syncWithUser(newValue.theme_color);
      }
    });


    this.setupProgressBar();

    this.setupTicketOnlyGuard();

    this.setupDynamicTitle(router);

    this.splitPreviewService.state$.subscribe((state) => {
      const visible = !!state?.visible;
      document.body.classList.toggle('split-preview-active', visible);
    });

  }

  /**
   * This function observes events from router and sets the title of the html document based on the data of the route.
   *
   * @param router the router that gives events that we subscribe to
   */
  private setupDynamicTitle(router: Router) {
    router.events.pipe(filter((ev) => ev instanceof NavigationEnd), map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild)
          route = route.firstChild;
        return route;
      })).subscribe((activatedRoute: ActivatedRoute) => {
        this.title.setTitle(activatedRoute.snapshot.data['title'] || 'Gestionale Incarichi');
      });
  }

  /**
   * Makes sure that when a user navigates to a route, the mat progress bar gets activated and displayed to the user.
   */
  private setupProgressBar() {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }




  private setupTicketOnlyGuard() {
    this.router.events.pipe(
      filter((ev) => ev instanceof NavigationEnd)
    ).subscribe((ev: NavigationEnd) => {
      if (this.user?.isTicketOnly() && !ev.urlAfterRedirects.startsWith('/tickets')) {
        this.router.navigateByUrl('/tickets');
      }
    });
  }

  public logout() {
    this.splitPreviewService.close();
    this.themeService.resetTheme();
    this.authService.logout();
    this.toastr.success('Logout Riuscito!', 'Successo!');
  }

  public apriTicket() {
    const dialogRef = this.dialog.open(TicketDialogComponent, { width: '500px' });
    dialogRef.afterClosed().subscribe(async (data) => {
      if (data) {
        try {
          const files: File[] = data._files || [];
          delete data._files;
          const created = await this.ticketService.create(data);
          const createdId = created?.['id'] || created?.['data']?.['id'];
          if (files.length && createdId) {
            for (const file of files) {
              await this.ticketService.uploadAllegato(createdId, file).toPromise();
            }
          }
          this.toastr.success('Ticket inviato con successo!', 'Successo!');
        } catch (e) {
          this.toastr.error('Errore durante l\'invio del ticket.', 'Errore');
        }
      }
    });
  }

}
